// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SnackbarWrapper div.notificationSnackbarStyle.snackbar[data-v-b28bbaae]{box-shadow:0 1px 8px 0 rgba(43,38,36,.3)}.SnackbarWrapper .snackbar.notificationSnackbarStyle .fas[data-v-b28bbaae],.SnackbarWrapper div.notificationSnackbarStyle.snackbar[data-v-b28bbaae]{max-width:266px;background-color:var(--color-white);color:var(--color-hemp-grey)}", ""]);
// Exports
module.exports = exports;
